import { getLob } from '../../../services/authenticationService';
import { PendingChange, TableData } from '../../../types/types';
import { fetchCountForTable, fetchDataForTable, raiseRequest } from '../../../services/checkalter';

export async function fetchTableData(
  selectedOption: string,
  offset: number = 0,
  limit: number = 1000
): Promise<TableData> {
  try {
    const res = await fetchDataForTable(selectedOption, offset, limit);

    return {
      data: Array.isArray(res.data) ? res.data : 
            typeof res.data === 'string' ? JSON.parse(res.data) :
            res.data ? [res.data] : [],
      total: res.total || 0
    };
  } catch (error) {
    console.error('Error fetching table data:', error);
    throw error;
  }
}

export async function fetchCount(tableName: string): Promise<number> {
  try {
    const res = await fetchCountForTable(tableName);
    return res.data.features[0];
  } catch (error) {
    throw error;
  }
}

export const handleLogout = (): void => {
  localStorage.removeItem('auth_cookie');
  localStorage.removeItem('email');
  localStorage.removeItem('username');
};

export async function commitChanges(changes: PendingChange[], approver: string, context: string): Promise<any> {
  const username = localStorage.getItem('username') || localStorage.getItem('email');

  try {
    const payload = {
      changes: changes.map(change => ({
        tableName: change.tableName,
        id: change.id,
        operation: change.operation, 
        logs: change.changes.map(c => ({
          key: c.key,
          oldValue: c.oldValue,
          newValue: c.newValue
        }))
      })),
      metadata: {
        username: username,
        context: context,
        lob: getLob(),
        approver: approver
      }
    };
    
    return await raiseRequest(payload);
  } catch (error) {
    console.error('Error committing changes:', error);
    throw error;
  }
}

export async function deleteRecord(id: string, record: any, tableName: string, approver: string, context:string): Promise<any> {
  const username = localStorage.getItem('username') || localStorage.getItem('email');

  const payload = {
    changes: [{
      tableName,
      id,
      operation: "DELETE", 
      logs: Object.entries(record).map(([key, value]) => ({
        key,
        oldValue: value,
        newValue: null 
      }))
    }],
    metadata: {
      username: username,
      context: context,
      lob: getLob(),
      approver: approver
    }
  };
  
  return await raiseRequest(payload);
}

export async function insertRecord(newRecord: any, tableName: string, approver: string, context:string): Promise<any> {
  const username = localStorage.getItem('username') || localStorage.getItem('email');

  const payload = {
    changes: [{
      tableName,
      id: Date.now().toString(),
      operation: "INSERT",
      logs: Object.entries(newRecord).map(([key, value]) => ({
        key,
        oldValue: null,
        newValue: value
      }))
    }],
    metadata: {
      username: username,
      context: context,
      lob: getLob(),
      approver: approver
    }
  };

  return await raiseRequest(payload);
}

export default {
  fetchTableData,
  fetchCount,
  commitChanges,
  deleteRecord,
  insertRecord,
  handleLogout
};